module.exports = __webpack_public_path__ + "img/a12.3c8c28f3.png";